import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import fetch from 'cross-fetch'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const fetchCustomCategory = async ({parameters, token, locale, site, origin}) => {
    const params = {...parameters}
    params.locale = locale?.id || locale
    params.alias = locale?.alias || locale
    params.site = site?.id || site

    const headers = {
        authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        'Content-Type': 'application/json',
    }

    const endpoint = origin + getMrtApiBasepath('/get-category-details')
    const response = await fetch(`${endpoint}?${new URLSearchParams(params)}`, {
        headers,
    })
    const data = await response.json()
    if (!response.ok && response.status === 404) {
        const error = new Error(data?.error || 'Failed to fetch category details')
        error.statusCode = response.status
        // redirect to 404 is handled by the pages automatically when there is an error in the category response
    } else {
        const error = new Error(data?.error || 'Failed to fetch category details')
        error.statusCode = response.status
        throw error
    }

    return data
}

export const useCustomGetCategory = ({parameters}, requestOptions) => {
    const {getTokenWhenReady} = useAccessToken()
    const {site, locale} = useMultiSite()
    const origin = useAppOrigin()

    return useQuery(
        ['getCategoryCustom', parameters.urlSegment, locale.id],
        async () => {
            const token = await getTokenWhenReady()
            return fetchCustomCategory({parameters, token, locale, site, origin})
        },
        {
            ...requestOptions,
            suspense: typeof window === 'undefined',
        },
    )
}

export default useCustomGetCategory
